import * as React from "react";
import Grid from "@mui/material/Grid";
import moment from "moment";
import { Typography } from "@mui/material";
export const DispatchVarianceTblCard = ({ data = [], onClick = () => {} }) => {
  return (
    <Grid container spacing={1} className="easy-putaway-container mt-1">
      {data.map((item, index) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          key={index}
          onClick={() => {
            let items = { row: item };
            onClick(items);
          }}
        >
          <div className="easy-putaway-card">
            <Grid container spacing={0.5} columns={{ xs: 12, md: 12 }}>
              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                Item Code
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item.ItmCd}
                </Typography>
              </Grid>

              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                INVQty
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item.INVQty}
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                DispatchedQty
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item.DispatchedQty}
                </Typography>
              </Grid>

              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                Difference
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item.Difference}
                </Typography>
              </Grid>

              <Grid item xs={12} md={12}>
                <Typography variant="subtitle1" className="value">
                  {item.Name1}
                </Typography>
              </Grid>
            </Grid>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};
